import {
  Directive,
  Input,
  HostListener,
  ElementRef,
  OnInit,
  AfterViewChecked,
  Inject
} from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';

@Directive({
  selector: '[appHoverScroll]'
})
export class HoverScrollDirective implements OnInit, AfterViewChecked {
  @Input() direction: string;
  @Input() isScrollbarHidden: boolean = false;
  scrollbarWidth: string;
  wrapper: HTMLDivElement;
  parentNode: HTMLElement;
  xDisabled: boolean = false;
  yDisabled: boolean = false;

  constructor(
    private element: ElementRef,
    @Inject('WINDOW') private window: any,
    @Inject(DOCUMENT) private document: any
  ) {
    this.scrollbarWidth = `${this.getScrollbarWidth()}px`;
    element.nativeElement.style.overflow = 'auto';
    element.nativeElement.style.whiteSpace = 'noWrap';
  }

  ngOnInit(): void {
    if (this.window) {
      const displayType = this.window.getComputedStyle(this.element.nativeElement).display;
      this.element.nativeElement.style.display = displayType;
    }

    if (this.direction === 'horizontal') {
      this.disableScroll('y');
      this.yDisabled = true;
    } else if (this.direction === 'vertical') {
      this.disableScroll('x');
      this.xDisabled = true;
    }

    if (this.isScrollbarHidden) {
      this.hideScrollbar();
    }
  }

  ngAfterViewChecked(): void {
    // avoid extra ckecks
    if (this.wrapper) {
      this.checkScrollbar();
    }
  }

  // @HostListener('mouseenter', ['$event'])
  // onMouseEnter($event: MouseEvent): void {
  //   this.setElementScroll($event);
  // }

  @HostListener('mousemove', ['$event'])
  onMousemove($event: MouseEvent): void {
    if (this.window) {
      if (this.window.innerWidth > 600) {
        this.setElementScroll($event);
      } // TODO: find a better solution
    }
  }

  private setElementScroll($event: MouseEvent): void {
    let speed;
    const elemRect = this.element.nativeElement.getBoundingClientRect();

    if (!this.xDisabled) {
      speed = this.element.nativeElement.children[0].scrollWidth / this.element.nativeElement.clientWidth;
      this.element.nativeElement.scrollLeft = ($event.clientX - elemRect.left) * speed;
    }

    if (!this.yDisabled) {
      speed = this.element.nativeElement.children[0].scrollHeight / this.element.nativeElement.clientHeight;
      this.element.nativeElement.scrollTop = ($event.clientY - elemRect.top) * speed;
    }
  }

  private disableScroll(axis: string): void {
    this.element.nativeElement.style[`overflow-${axis}`] = 'hidden';
  }

  // uncomment if needed
  // private enableScroll(axis: string): void {
  //   this.element.nativeElement.style[`overflow-${axis}`] = 'auto';
  // }

  private checkScrollbar(): void {
    if (this.element.nativeElement.scrollWidth <= this.element.nativeElement.clientWidth) {
      this.element.nativeElement.style.height = '100%';
    } else {
      this.element.nativeElement.style.height = `calc(100% + ${this.scrollbarWidth})`;
    }

    if (this.element.nativeElement.scrollHeight <= this.element.nativeElement.clientHeight) {
      this.element.nativeElement.style.width = '100%';
    } else {
      this.element.nativeElement.style.width = `calc(100% + ${this.scrollbarWidth})`;
    }
  }

  private hideScrollbar(): void {
    if (this.element.nativeElement.style.display !== 'none') {
      this.parentNode = this.element.nativeElement.parentNode;
      this.wrapper = this.document.createElement('div');
      this.wrapper.style.width = '100%';
      // this.wrapper.style.width = this.element.nativeElement.offsetWidth + 'px';
      this.wrapper.style.height = this.element.nativeElement.offsetHeight + 'px';
      this.wrapper.style.overflow = 'hidden';
      this.element.nativeElement.style.width += `calc(100% + ${this.scrollbarWidth})`;
      this.element.nativeElement.style.height += `calc(100% + ${this.scrollbarWidth})`;
      // set the wrapper as child (instead of the element)
      this.parentNode.replaceChild(this.wrapper, this.element.nativeElement);
      // set element as child of wrapper
      this.wrapper.appendChild(this.element.nativeElement);
    }
  }

  // uncomment if needed
  // private showScrollbar(): void {
  //   if (this.wrapper) {
  //     this.element.nativeElement.style.width = this.wrapper.style.width;
  //     this.element.nativeElement.style.height = this.wrapper.style.height;
  //     this.parentNode.removeChild(this.wrapper);
  //     this.parentNode.appendChild(this.element.nativeElement);
  //     this.wrapper = null;
  //   }
  // }

  private getScrollbarWidth(): number {
    const outer = this.document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.width = '100px';
    outer.style.msOverflowStyle = 'scrollbar';

    this.document.body.appendChild(outer);
    const widthNoScroll = outer.offsetWidth;
    outer.style.overflow = 'scroll';

    // add innerdiv
    const inner = this.document.createElement('div');
    inner.style.width = '100%';
    outer.appendChild(inner);

    const widthWithScroll = inner.offsetWidth;

    // remove divs
    outer.parentNode.removeChild(outer);

    return widthNoScroll - widthWithScroll || 20;
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/directives/hover-scroll.directive.ts